import { createContext } from 'react';

import { IFetchPrivateStatsParams } from 'modules/stats/actions/fetchPrivateStats';
import { StatsTimeframe } from 'modules/stats/types';

export const ChainsPrivateStatsContext =
  createContext<IFetchPrivateStatsParams>({
    timeframe: StatsTimeframe.Day,
    workerToken: '',
  });
